import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

export const useClientGroups = (page = 1, limit = 100, search = "") => {
  const queryClient = useQueryClient();

  const query = useQuery(
    ["clientGroups", page, limit, search],
    () => fetchData(`/clients-groups?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}`),
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      select: (response) => ({
        groups: response?.data || [],                 // lista plana com {id, nome, id_pai, ordem, excluido, ...}
        pagination: response?.pagination || { total: 0 },
      }),
    }
  );

  const updateMutation = useMutation(
    (group) => {
      const method = group?.id ? "PUT" : "POST";
      const endpoint = group?.id ? `/clients-groups/${group.id}` : `/clients-groups`;
      return fetchData(endpoint, method, group);
    },
    { onSuccess: () => queryClient.invalidateQueries("clientGroups") }
  );

  const deleteMutation = useMutation(
    (id) => fetchData(`/clients-groups/${id}`, "DELETE"),
    { onSuccess: () => queryClient.invalidateQueries("clientGroups") }
  );

  return { ...query, updateMutation, deleteMutation };
};
